import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";

import { useCreateNotificationMutation } from "@modules/notifications/services/mutations";
import { NotificationFormValues, notificationSchema } from "@modules/notifications/validations";

export function useNotificationCreateForm() {
  const { mutateAsync, isPending } = useCreateNotificationMutation();

  const methods = useForm<NotificationFormValues>({
    resolver: zodResolver(notificationSchema()),
    defaultValues: {
      notification_type: "email",
      schedule_type: "one_time",
      agreement: null,
      emails_text: "",
      email_subject: "",
      email_body: "",
      push_subject: "",
      push_body: "",
      date: "",
      time: "",
      days_of_week: [],
    },
    // onChange: o erro some enquanto digita; no blur ele sumia e deslocava o botão "Próximo" no meio do clique
    mode: "onChange",
  });

  return {
    methods,
    isPending,
    onSubmit: methods.handleSubmit((values) => mutateAsync(values)),
  };
}
